import type { paths } from '@luxuryescapes/contract-trip'
import request from 'api/requestUtils'
import { baseUri, getOptions } from 'tripPlanner/api/utils'

type GetLegacyTripArchiveResponse =
  paths['/api/trips/legacy-archives/{tripId}']['get']['responses']['200']['content']['application/json']
type GetLegacyTripArchivePageResponse =
  paths['/api/trips/legacy-archives']['get']['responses']['200']['content']['application/json']

export type LegacyTripArchive = GetLegacyTripArchiveResponse['result']
export type LegacyTripArchivePage = GetLegacyTripArchivePageResponse['result']
export type LegacyTripArchiveSummary = LegacyTripArchivePage['trips'][number]

const archiveUri = `${baseUri}/legacy-archives`

export async function getLegacyTripArchive(tripId: string, accessToken?: string): Promise<LegacyTripArchive> {
  const uri = `${archiveUri}/${encodeURIComponent(tripId)}`
  const response = await request.get<GetLegacyTripArchiveResponse>(uri, getOptions(accessToken))
  return response.result
}

export async function getLegacyTripArchivePage(cursor?: string, accessToken?: string): Promise<LegacyTripArchivePage> {
  const query = new URLSearchParams({ limit: '100' })
  if (cursor) query.set('cursor', cursor)
  const response = await request.get<GetLegacyTripArchivePageResponse>(`${archiveUri}?${query}`, getOptions(accessToken))
  return response.result
}

export async function getLegacyTripArchives(accessToken?: string): Promise<Array<LegacyTripArchiveSummary>> {
  const trips: Array<LegacyTripArchiveSummary> = []
  const visitedCursors = new Set<string>()
  let cursor: string | undefined
  do {
    const page = await getLegacyTripArchivePage(cursor, accessToken)
    trips.push(...page.trips)
    cursor = page.nextCursor
    if (cursor && visitedCursors.has(cursor)) {
      throw new Error('The archived trip list could not be loaded completely.')
    }
    if (cursor) visitedCursors.add(cursor)
  } while (cursor)
  return trips
}
